
import Seo from '../../components/Seo';
const DOTS = (
  <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
);

const CHK = (
  <svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg>
);

export default function OrgIntelligencePage() {
  
  return (
    <>
      <Seo title="Org Intelligence — AI Work Pattern Analysis | TeamGrid™" description="Company-wide AI analysis that names what your teams do well, what is quietly breaking, and the one change to make this week. Patterns, not people." />
      <header className="fh">
        <div className="fh-grid">
          <div className="fh-copy">
            <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />AI Intelligence <span className="arr">›</span></span>
            <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '26px', maxWidth: '780px'}}>Patterns you would<br /><span style={{color: '#a9aab3'}}>never find by hand</span></h1>
            <p style={{maxWidth: '620px', marginBottom: '26px', fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)'}}>TeamGrid reads thousands of data points across the company and comes back with what your team is good at, what is quietly breaking, and what to do about it this week.</p>
            <ul className="hero-checks">
              <li>{CHK}<span><b>Strengths detection.</b> What the team does exceptionally well.</span></li>
              <li>{CHK}<span><b>Issue identification.</b> Bottlenecks caught before deadlines move.</span></li>
              <li>{CHK}<span><b>Smart recommendations.</b> Steps that worked for similar teams.</span></li>
            </ul>
            <div className="hero-cta-row">
              <a className="btn-primary" href="/register">Run the analysis free</a>
              <span className="hero-cta-note">7-day free trial.<br />No credit card.</span>
            </div>
          </div>
          <div className="fh-vis">
            <div className="frame">
              <div className="frame-h">{DOTS}ORG ANALYSIS — 8 TEAMS SCANNED</div>
              <div className="anlist" style={{paddingBottom: '8px'}}>
                <div className="ancard">
                  <span className="aico" style={{background: '#E6F6EC'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#34A851" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg></span>
                  <span><span className="at" style={{color: '#34A851'}}>STRENGTH</span><span className="am">Design has shipped <b>2 days early</b> for three sprints</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#FDEDE9'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#E0483D" strokeWidth="2.2" strokeLinecap="round" d="M8 2.5 15 14H1L8 2.5ZM8 7v3.2M8 12.1v.1" /></svg></span>
                  <span><span className="at" style={{color: '#E0483D'}}>ISSUE</span><span className="am">Code reviews now wait <b>9h</b> — up from 4h</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#EAF2FB'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#366EB6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" d="M1.8 11.6 6 6.9l3.1 2.7L14.2 4M14.2 4H10.4M14.2 4v3.7" /></svg></span>
                  <span><span className="at" style={{color: '#366EB6'}}>FORECAST</span><span className="am">Support load trending <b>+12%</b> into next week</span></span>
                </div>
              </div>
              <div className="applist" style={{padding: '12px 18px 16px', borderTop: '1px solid var(--line-soft)'}}>
                <span className="ap">Strengths<span className="bar"><b style={{width: '100%', background: '#34A851'}}></b></span><span className="pc">5</span></span>
                <span className="ap">Issues<span className="bar"><b style={{width: '80%', background: '#F2673A'}}></b></span><span className="pc">4</span></span>
                <span className="ap">Actions<span className="bar"><b style={{width: '60%', background: '#8B75D7'}}></b></span><span className="pc">3</span></span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <h2 className="sect-h2">Understand work<br /><span className="dim">like never before</span></h2>
          <p className="sect-sub">Company-wide analysis, drawn from work patterns. <span className="def" title="Patterns, not people: we measure the shape of work — never its private content.">Patterns, not people</span> — no screenshots, no keystrokes.</p>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#2DBDB8'}}>STRENGTHS &amp; ISSUES</span>
              <h3>Five things going right, four worth fixing</h3>
              <p className="fd">Each month the analysis names what is working and what is not, per team, with the number behind it. No survey to send, no retro to schedule before you know where to look.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Strengths detected automatically, then ranked</li>
                <li><span className="sarr">→</span>Bottlenecks named while deadlines are still safe</li>
                <li><span className="sarr">→</span>Workload balance and performance trends at scale</li>
              </ul>
            </div>
            <div className="frame">
              <div className="frame-h">{DOTS}AI ANALYSIS — ENGINEERING · THIS MONTH</div>
              <div className="anlist">
                <div className="ancard">
                  <span className="aico" style={{background: '#E6F6EC'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#34A851" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg></span>
                  <span><span className="at" style={{color: '#34A851'}}>STRENGTH · 5 FOUND</span><span className="am">Mid-week productivity peaks at <b>87%</b></span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#E6F6EC'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#34A851" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg></span>
                  <span><span className="at" style={{color: '#34A851'}}>STRENGTH</span><span className="am"><b>Zero idle time</b> during core hours</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#FDEDE9'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#E0483D" strokeWidth="2.2" strokeLinecap="round" d="M8 2.5 15 14H1L8 2.5ZM8 7v3.2M8 12.1v.1" /></svg></span>
                  <span><span className="at" style={{color: '#E0483D'}}>ISSUE · 4 FOUND</span><span className="am">Monday productivity <b>−23%</b> versus average</span></span>
                </div>
                <div className="ancard">
                  <span className="aico" style={{background: '#FDEDE9'}}><svg viewBox="0 0 16 16" width="15" height="15"><path fill="none" stroke="#E0483D" strokeWidth="2.2" strokeLinecap="round" d="M8 2.5 15 14H1L8 2.5ZM8 7v3.2M8 12.1v.1" /></svg></span>
                  <span><span className="at" style={{color: '#E0483D'}}>ISSUE</span><span className="am">Documentation gaps appearing in sprints</span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="frow rev">
            <div className="frame sumcard">
              <div className="sc-t">AI RECOMMENDATION — ENGINEERING</div>
              <p style={{fontSize: '13.5px', lineHeight: '20px'}}>Move Monday standups to <b>9:30 AM</b>. Teams with early standups show <b style={{color: '#1d7a43'}}>18% higher Monday productivity</b>. This change alone could recover roughly <b>4 hours a week</b>.</p>
            </div>
            <div className="fr-copy">
              <span className="fl" style={{color: '#8B75D7'}}>SMART RECOMMENDATIONS</span>
              <h3>Advice with a number attached</h3>
              <p className="fd">Not &ldquo;improve collaboration&rdquo;. A specific change, the evidence from teams like yours, and the hours it is expected to give back. Implement it Monday, check the result Friday.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Based on what works for similar teams</li>
                <li><span className="sarr">→</span>Every suggestion carries its expected gain</li>
                <li><span className="sarr">→</span>Specific enough to act on the same day</li>
              </ul>
            </div>
          </div>

          <div className="frow">
            <div className="fr-copy">
              <span className="fl" style={{color: '#469FD8'}}>PATTERN RECOGNITION</span>
              <h3>Whole-company patterns, found automatically</h3>
              <p className="fd">The analysis runs across every team, not one department at a time. It forecasts where productivity is heading and catches problems on the way up, not after they land.</p>
              <ul className="fpts">
                <li><span className="sarr">→</span>Patterns identified across the entire organization</li>
                <li><span className="sarr">→</span>Trends forecast before they become incidents</li>
                <li><span className="sarr">→</span>Team-level first, aggregated and anonymized</li>
              </ul>
            </div>
            <div className="frame">
              <div className="frame-h">{DOTS}WEEKDAY PATTERN — ALL TEAMS</div>
              <div className="applist" style={{padding: '16px 18px'}}>
                <span className="ap">Monday<span className="bar"><b style={{width: '54%', background: '#E0483D'}}></b></span><span className="pc">−23%</span></span>
                <span className="ap">Tuesday<span className="bar"><b style={{width: '82%', background: '#2DBDB8'}}></b></span><span className="pc">82%</span></span>
                <span className="ap">Wednesday<span className="bar"><b style={{width: '87%', background: '#34A851'}}></b></span><span className="pc">87%</span></span>
                <span className="ap">Thursday<span className="bar"><b style={{width: '80%', background: '#2DBDB8'}}></b></span><span className="pc">80%</span></span>
                <span className="ap">Friday<span className="bar"><b style={{width: '66%', background: '#F2A73A'}}></b></span><span className="pc">66%</span></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <div className="roi-cards" style={{marginTop: '0'}}>
            <div className="roi-card"><div className="rl">STRENGTHS FOUND</div><div className="rv">5</div><p>In one month for one team, surfaced without sending a single survey.</p></div>
            <div className="roi-card"><div className="rl">ISSUES FLAGGED</div><div className="rv">4</div><p>Bottlenecks named early, while the deadline is still reachable.</p></div>
            <div className="roi-card"><div className="rl">MONDAY GAP</div><div className="rv">−23%</div><p>The pattern nobody noticed until the analysis went looking for it.</p></div>
            <div className="roi-card"><div className="rl">HOURS RECOVERED</div><div className="rv">~4/wk</div><p>From one scheduling change the recommendation engine proposed.</p></div>
          </div>
        </div>
      </section>

      <div className="container"><p className="roi-note" style={{margin: '0 0 4px'}}>*Sample analysis shown. Your findings come from your own workspace data.</p></div>
      <div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/pattern-intelligence">Pattern Intelligence →</a><a href="/monitoring">Monitoring →</a></div></div>

      <section className="sect" style={{padding: '8px 0 24px'}}>
        <div className="container">
          <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
          <div className="faq">
            <details><summary>What does Org Intelligence actually deliver?</summary><p>It aggregates team data to spotlight organizational patterns, workload balance, performance trends and opportunities to improve at scale — with the strengths, issues and recommended actions written out.</p></details>
            <details><summary>Is this analysing individual people?</summary><p>No. Analysis runs on work patterns at team and company level. There are no screenshots and no keystrokes, and person-level detail follows your own consent rules.</p></details>
            <details><summary>How is a recommendation different from a report?</summary><p>A report tells you Monday is down 23%. A recommendation tells you to move standups to 9:30 AM, shows the 18% lift other teams saw, and estimates the four hours a week it gives back.</p></details>
          </div>
        </div>
      </section>

      <section className="final" style={{paddingTop: '48px'}}>
        <div className="container-wide">
          <div className="final-band" style={{paddingBottom: '88px'}}>
            <h2>See what your company<br />has been doing all along</h2>
            <a className="btn-white" href="/register">Get started FREE</a>
          </div>
        </div>
      </section>
    </>
  );
}
